import { Colors, ColorValues, Flex, IconCheck } from '@banhala/ui-kit';

interface SelectionCheckBoxProps {
  isSelected: boolean;
}

export const SelectionCheckBox = ({ isSelected }: SelectionCheckBoxProps) => (
  <Flex.Center
    position={'absolute'}
    top={16}
    right={16}
    width={24}
    height={24}
    borderRadius={12}
    borderWidth={2}
    borderColor={'white'}
    backgroundColor={isSelected ? 'bg_blue_primary' : undefined}
    backgroundColorValue={isSelected ? undefined : ColorValues.alpha_dark10}
    pointerEvents={'none'}
  >
    {isSelected && <IconCheck size={16} fill={Colors.content_always_white} />}
  </Flex.Center>
);
